/**
 * Firebase Storage path for the NYCBS Stat bulk upload template CSV.
 */
export const STAT_TEMPLATE_PATH =
  "samples/NYCBS_STAT_RisaHealth_yyyymmddhhmm.csv";
